export const ru = {
    title: 'Выбрать пользователей',
    info: 'Тревел-политика данной группы будет действовать на всех добавленных в группу пользователей',
    confirmation_title: 'Заменить тревел политику',
    confirmation_info: 'Для некоторых пользователей уже была выбрана тревел-политика или группа. Хотите заменить их на новую?',
};
